import { render } from "./dashboard-start-navbar.vue?vue&type=template&id=672cae37&ts=true"
import script from "./dashboard-start-navbar.vue?vue&type=script&lang=ts"
export * from "./dashboard-start-navbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__